import { render } from "./CambioValutaForm.vue?vue&type=template&id=32f99dc8&ts=true"
import script from "./CambioValutaForm.vue?vue&type=script&lang=ts"
export * from "./CambioValutaForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__